import React from 'react';
import { connect } from 'react-redux';
import { v4 } from 'uuid';

import RetentionComplex from '../../components/retention/RetentionComplex';
import {
  getExecuteIdsFromJobIds,
  getRetentionComplexExecuteId,
  getRetentionComplexFirstEvent,
  getRetentionComplexReturnEvent,
  isRetentionComplexExecuting,
} from '../../reducers/analyticsApp';
import {
  executeRetentionComplex,
  executeRetentionComplexCsv,
  setRetentionComplexExecuteId,
} from '../../actions/retention/retentionComplex';
import { cancelRequest } from '../../api/execute';
import CsvDownloadButton from '../navigation/csv/CsvDownloadButton';
import CsvRequests from '../navigation/csv/CsvRequests';

const isExecuteDisabled = (state) =>
  [getRetentionComplexFirstEvent(state), getRetentionComplexReturnEvent(state)].some(
    (item) => !item
  );

const mapStateToProps = (state) => {
  const executeIds = getExecuteIdsFromJobIds(state);
  const executeId = getRetentionComplexExecuteId(state);

  return {
    executing: isRetentionComplexExecuting(state),
    executeDisabled: isExecuteDisabled(state),
    cancelButtonDisabled: !executeIds.includes(executeId),
    executeId,
    extraActions: [
      {
        renderElement: (closeMenu) => (
          <CsvDownloadButton
            title="Download CSV"
            clickHandler={executeRetentionComplexCsv}
            closeMenu={closeMenu}
          />
        ),
      },
      { renderElement: (closeMenu) => <CsvRequests closeMenu={closeMenu} /> },
    ],
  };
};

const mapDispatchToProps = (dispatch) => ({
  onExecute: () => {
    const executeId = v4();
    dispatch(setRetentionComplexExecuteId(executeId));
    return dispatch(executeRetentionComplex(executeId));
  },
  onRequestCancel: (executeId) => dispatch(cancelRequest(executeId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onRequestCancel: () => dispatchProps.onRequestCancel(stateProps.executeId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(RetentionComplex);
